import { jsx as _jsx } from "react/jsx-runtime";
import { LocalConfigProvider } from './LocalConfigProvider';
import { RemoteConfigProviderWrap } from './RemoteConfigProvider';
export const ConfigProvider = ({ children, defaults }) => {
    return (_jsx(LocalConfigProvider, { children: _jsx(RemoteConfigProviderWrap, { defaults: defaults, children: children }) }));
};
//# sourceMappingURL=ConfigProvider.js.map